
<style>
  .form-material select, .form-material input, .form-material textarea, languageSelector select {
    width: 100%;
    font-size:14px;
  }

.form-material select {
  font-size:14px;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.languageContainer {
  display:block;
  margin-bottom:10px;
}

.globalContainer {
  display:block;
  margin-bottom:10px;
  padding:12px;
}

textarea {min-height: 100px;}

</style>

<app-modal-header [headerTitle]="'Edit Lectionary Item'" (languageSelected)="setSelectedLanguage($event)"></app-modal-header>


<div class="globalContainer" *ngIf="item != null && listsLoaded == true">

    <div  style="border-bottom:1px solid gray">All Languages</div>

    <div class="form-group row">

      <div class="col-6">

          <div class="">
              <div class="form-material">
    
                  <select  [ngModel]="item.LectionaryItemName?.LectionaryItemType?.Id"  (ngModelChange)="lecctionaryItemTypeValueChanged($event)">
                      <option *ngFor="let section of lectionaryItemTypes" [ngValue]="section.Id">
                        {{section.Localized[0].Name}}
                      </option>
                    </select>
    
                  <label for="">Lectionary Item Type</label>
    
              </div>
          </div>

          
        <div class="form-material">

          <select name="LectionaryItemName" *ngIf="isLoadingLectionaryItemNames == false" [ngModel]="item.LectionaryItemName?.Id" (ngModelChange)="item.LectionaryItemName = setModelValue($event, item.LectionaryItemName)">
              <option *ngFor="let section of lectionaryItemNames" [ngValue]="section.Id">
                {{section.Name}}
              </option>
            </select>

            <div *ngIf="isLoadingLectionaryItemNames == true">
              Loading Lectionary Item Names, one moment please
            </div>
            
          <label for="">Lectionary Item Name</label>

        </div>


   
        <div class="">

            <div class="form-material" >

                <select  [ngModel]="item.LanguageStyle?.Id" (ngModelChange)="item.LanguageStyle = setModelValue($event, item.LanguageStyle)">
                    <option></option>
                    <option *ngFor="let section of languageStyles" [ngValue]="section.Id">
                        {{section.Id}} - {{section.Localized[0].Name}}
                    </option>
                  </select>

                <label for="">Language Style</label>

            </div>

        </div>
  
        <div class="row col-12x">
          <div class="col-5">
            <div class="form-material">

                <select [ngModel]="item.LectionarySource?.Id" (ngModelChange)="item.LectionarySource = setModelValue($event, item.LectionarySource)">
                    <option *ngFor="let section of lectionarySources" [ngValue]="section.Id">
                        {{section.Name}}
                    </option>
                  </select>

                <label for="">Text Source</label>

            </div>
          </div>
          
          <div class="col-4"> 
            <div class="form-material">
              <input type="text" matInput [(ngModel)]="item.LectionarySourcePageNumber"/>
              <label for="">Text Page Number</label>
            </div> 
          </div>

          <div class="col-3"> 
            <div class="form-materialx" style="padding-top:7px;">
 
                <div style="font-weight:600;">Is Active</div>
                <input type="checkbox" [(ngModel)]="item.IsActive">
              
             
            </div> 
          </div>
        </div>


      </div>

        <div class="col-6"> 
          <div class=""> 
              <div class="form-material">
                  <input type="text" matInput [(ngModel)]="item.ProofedByName" readonly/>
                  <label for="">Proofed</label>
              </div>
          </div>
                

          <div class=""> 
              <div class="form-material">
                  <textarea matInput class="txtComments" [(ngModel)]="item.Comments"></textarea>
                  <label for="">Comments</label>
              </div>
          </div>
        </div>
 
    <div class="col-12">
    </div>

      <div class="col-12">
          <div class="form-material htmlEditorContainer">
            
            <div *ngIf="isPsalmDetected" class="readOnlyNotice">
              To edit, use the Admin - Psalter tool 

            
              <app-lectionary-item-html-editor [textAreaValue]="psalterHtml" [isReadOnly]="isHtmlEditorReadOnly" (valueChanged)="htmlChanged($event)"></app-lectionary-item-html-editor>
             
            </div>
 
            <div *ngIf="isPsalmDetected == false"> 
              <app-lectionary-item-html-editor [textAreaValue]="item.HTML" [isReadOnly]="false" (valueChanged)="htmlChanged($event)"></app-lectionary-item-html-editor>
            </div>

       
          
          </div>
      </div>

 
 

  </div>

  <div class="row">

    <div class="col-sm-4">
        <app-display-matching-pronunciatons [lectionaryItemId]="item.Id"></app-display-matching-pronunciatons>
    </div> 

    <div class="col-sm-8">

      <div mat-dialog-actions class="float-right">
        <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
        <!-- <button mat-button (click)="validateBeforeSave()" class="btn btn-sm btn-outline-primary" style="margin-right:10px">Validate Html</button> -->
        <button mat-button (click)="save(false)" class="btn btn-sm btn-outline-primary" style="margin-right:10px">{{saveButtonText}}</button>
        <button mat-button (click)="save(true)" class="btn btn-sm btn-outline-primary">Save and Proof</button>
      </div>

    </div>
</div>


</div>



